<template>
  <div class="homecontainer _homecontainer">
    <MainTop :titlename="$i18n.locale=='zh_HK'?list.title:list.titleEn" :imgsrc="getimgsrc(list.titleImg)" :type="3"
    :textContent="$i18n.locale=='zh_HK'?list.titleDescribe:list.titleDescribeEn"/>
    <Facilitiescom  :listfac="listfacdata" />
    <Footer/>
  </div>
</template>
<script>
  import MainTop from '@/views/comcomponents/MainTop'
  import Footer from "@/views/comcomponents/Footer"
  import Facilitiescom from "./faccomponents/facilitiecom";
  import {getListFacilities} from '@/api/home';
  export default {
    name: 'Facilities',
    components: {
      MainTop,
      Facilitiescom,
      Footer
    },
    data(){
      return{
        list:'',
        listfacdata:'',
      }
    },
    created() {
      this.getListFacilities();
    },
    methods: {
      getListFacilities() {
        getListFacilities() .then(response => {
          const data = response.data;
          this.list=data.data[0];
          this.listfacdata= this.list.list;
        })
      },
      getimgsrc(imgvalue){
        if (imgvalue == null || imgvalue == '') {
          return '-'
        }
        var imgs = imgvalue.replace(/,/g, "")
        return process.env.BASE_IMG + imgs
      }
    },
  }
</script>

<style lang="less" scoped>

  // 大于800px
  @media only screen and (min-width: 800px){
    .homecontainer{
      font-size: 1vw;
      .subdiv{
        width: 100%;
        display: flex;
        justify-content: space-around;
        font-size: .5em;
        .left{
          width: 48%;
          height: 100%;
          font-size: .8em;
        }
        .right{
          width: 48%;
          height: 100%;
          font-size: .8em;
        }
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px){
    ._homecontainer{
      font-size: 1.5vw;
      ._subdiv{
        width: 100%;
        display: flex;
        flex-direction: column;
        // justify-content: space-around;
        font-size: .5em;
        .left{
          width: 100%;
          height: 100%;
          font-size: .8em;
        }
        .right{
          width: 100%;
          height: 100%;
          font-size: .8em;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Facilities/Facilities.vue